import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UrlProviderserviceService {

  private Services = {
    getContratos: 'contratos',
    getContratosMarca: 'ContratosMarca',
    saveRegistroVentas: 'RegistroVentas',
    saveRegistroVentasMarca: 'RegistroVentasMarca',
    getUsuario: 'Usuarios',
    getEdificiosConsulta: 'ConsultaVentas',
    getEdificiosConsultaMarca: 'ConsultaVentasMarca',
    getConsulta: 'ConsultaVentas/consultar',
    getConsultaMarca: 'ConsultaVentasMarca/consultar',
    actualizarConsulta: 'ConsultaVentas/actualizar',
    actualizarConsultaMarca: 'ConsultaVentasMarca/actualizar',
    getEdificiosRegistro: 'Contratos/edificios',
    getEdificiosRegistroMarca: 'ContratosMarca/edificios',
    validarUsuarioMarca: 'UsuarioMarca/validarmarca',
    obtenerusuario: 'AdministracionMaestros/obtenerUsuario',
    obtenermarcas:'AdministracionMaestros/obtenermarcas',
    obtenermarcasids:'AdministracionMaestros/obtenermarcasids',
    obteneredificios:'AdministracionMaestros/obteneredificios',
    crearUsuario: 'AdministracionMaestros/crearusuario',
    actualizarUsuario: 'AdministracionMaestros/actualizarUsuario',
    usuarioId:'AdministracionMaestros/usuarioId',
    deleteUser:'AdministracionMaestros/deleteUser',
    getConsultaReporte: 'ConsultaVentas/reporte',
    getMonitorVentas: 'Monitor/monitorventas',
    guardarRegistroVentasCertificadas: 'RegistroVentasCertificadas',
    guardarRegistroVentasCertificadasMarca: 'RegistroVentasCertificadasMarca',
    getConsultaMarcaCertificada:'ConsultaVentaMarcaCertificada/consultar',
    getConsultaCertificada:'ConsultaVentaCertificada/consultar',
    getMonitorVentasCertificadas:'MonitorVentasCertificadas/monitorventascertificadas',
    actualizarConsultaMarcaCertificada: 'MonitorVentasMarcaCertificadas/actualizar',
    actualizarConsultaCertificada:'MonitorVentasCertificadas/actualizar',
    guardarRegistroVentas:'ConsultaVentaCertificada/actualizar',
    guardarRegistroVentasMarca:'ConsultaVentaCertificada/actualizar',
    getConsultaReporteVentasCertificadas: 'ConsultaVentaCertificada/reporte',
    obtenerListadoClientes:'MonitorVentasCertificadas/informe',
    generarToken:'Usuarios/GenerarToken',
    cambiarContrasena:'Usuarios/ChangePassword',
    reporteMarcas:'ConsultaVentas/reporteMarcas',
    getSoporte:'ConsultaVentaCertificada/DescargaSoporte',
    getTodosCondicionesMovimientos: 'CondicionesMovimientos/listarTodos',
    condicionesMovimientos: 'CondicionesMovimientos',
    consultarFactura: 'RegistroVentasCertificadas/consultafactura',
    consultarFacturaMarca: 'RegistroVentasCertificadasMarca/consultafactura',
    getPrametros : 'Parametros',
    usuarioMarca : 'UsuarioMarca'
    
  };

  constructor() { }

  getApiUrl(name: string): string {
    return environment.baseUrl + this.Services[name];
  }
  getApiUrlExterno(name: string): string {
    return environment.baseUrlExterno + this.Services[name];
  }

}
